import { Card, CardContent } from "@/components/ui/card";
import TermsAndConditionsForm from "@/v2/components/pages/terms-and-conditions/Form";
import FormPageHeading from "@/v2/components/ui/heading/FormPage";
import { ReceiptTextIcon } from "lucide-react";

export default function AddTermsAndCondition() {
    return (
        <div className="my-3 min-h-screen">
            <Card className="rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
                <FormPageHeading
                    title={"Terms and Condition"}
                    description="Create and manage your supplier information and contacts"
                    Icon={ReceiptTextIcon}
                />
                <CardContent className="pt-6">
                    <TermsAndConditionsForm />
                </CardContent>
            </Card>
        </div>
    );
}
